import { useState, useEffect, useRef } from "react";
import Swiper, { Navigation, Pagination, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import useSWR from "swr";
import JobCardOld from "../../../components/jobs/JobCard2";
import { URLS } from "../../../services/urls";
import "../Home.css"; // Réutilisation des styles globaux
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const OldJob = () => {
  const { t } = useTranslation();
  const swiperRef = useRef(null);
  const swiperInstance = useRef(null);

  // État pour les données des jobs et la pagination
  const [page, setPage] = useState("");
  const { data: jobs, isLoading: loadingJobs } = useSWR(URLS.JOBS.search(page));

  // Initialisation de Swiper
  useEffect(() => {
    if (swiperRef.current && jobs?.results) {
        
      // Destruction de l'instance précédente si elle existe
      if (swiperInstance.current) swiperInstance.current.destroy();

      swiperInstance.current = new Swiper(swiperRef.current, {
        modules: [Navigation, Pagination, Autoplay],
        spaceBetween: 25,
        slidesPerView: 4, // 4 jobs par ligne c'est souvent mieux lisible que 6
        slidesPerGroup: 1,
        loop: jobs.results.length > 4, // Loop seulement s'il y a assez de contenu
        navigation: {
          nextEl: ".custom-job-next",
          prevEl: ".custom-job-prev",
        },
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
        breakpoints: {
          1360: { slidesPerView: 4 },
          1199: { slidesPerView: 3 },
          992: { slidesPerView: 2 },
          600: { slidesPerView: 1 },
          320: { slidesPerView: 1 },
        },
      });
    }

    return () => {
      if (swiperInstance.current) swiperInstance.current.destroy();
    };
  }, [jobs]);

  return (
    <section className="section-box mt-50 mb-50">
      <div className="container">
        
        {/* En-tête de section aligné */}
        <div className="d-flex justify-content-between align-items-end mb-40">
            <div>
                <h2 className="section-title mb-10 wow animate__animated animate__fadeInUp">
                    {t("AllJobs") || "Dernières Offres"}
                </h2>
                <p className="font-lg color-text-paragraph-2 wow animate__animated animate__fadeInUp">
                    {t("textJobSub") || "Découvrez les opportunités récentes ajoutées sur notre plateforme."}
                </p>
            </div>

            {/* Navigation Custom */}
            <div className="d-none d-md-flex gap-2 wow animate__animated animate__fadeInRight">
                <div className="custom-job-prev swiper-nav-btn">
                    <FontAwesomeIcon icon={faArrowLeft} />
                </div>
                <div className="custom-job-next swiper-nav-btn">
                    <FontAwesomeIcon icon={faArrowRight} />
                </div>
            </div>
        </div>

        {/* Loading State */}
        {loadingJobs && (
             <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status"></div>
             </div>
        )}

        <div className="box-swiper">
          <div className="swiper-container swiper" ref={swiperRef}>
            <div className="swiper-wrapper py-3"> {/* Padding pour les ombres */}
              {Array.isArray(jobs?.results) && jobs.results.map((job) => (
                <div key={"pop_job" + job.id} className="swiper-slide">
                  {/* On suppose que JobCardOld gère sa propre carte, 
                      on ajoute juste un wrapper pour l'effet hover global du slide */}
                  <div className="card-job-wrapper hover-up">
                    <JobCardOld job={job} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default OldJob;